import * as yup from 'yup';
import { parseCalendarDate } from '@shared/utils/date';

export const INVALID_DATE_MESSAGE = 'Select a valid date.';

/** Re-usable Yup schema for an optional `YYYY-MM-DD` calendar date field. */
export const calendarDateSchema = yup
  .string()
  .nullable()
  .defined()
  .test('calendar-date', INVALID_DATE_MESSAGE, (value) => value === null || parseCalendarDate(value) !== null);
